export enum CURRENCIES {
  GOLD = 'gold',
}
